import { Button, ButtonProps, ButtonStyles, Icons } from '@silverfort/sf-components';
import { FC, ReactNode } from 'react';
import { WizardPageSx } from './types';

export interface WizardPageProps {
    title: ReactNode;
    nextButtonProps?: ButtonProps;
    backButtonProps?: ButtonProps;
    cancelButtonProps?: ButtonProps;
    className?: string;
    sx?: WizardPageSx;
    children: ReactNode;
}

const WizardPage: FC<WizardPageProps> = ({
    title,
    nextButtonProps,
    backButtonProps,
    cancelButtonProps,
    className,
    sx,
    children
}) => {
    return (
        <div
            className={`h-full flex flex-col w-8/12 flex-1 bg-sf-white border border-sf-gray-100 rounded-2xl  ${className}`}
            style={sx?.root}>
            <div
                className="p-6 leading-[18px] bg-sf-gray-0 border-b border-sf-gray-100 flex flex-col justify-center text-15 font-sf-poppins font-medium rounded-t-2xl"
                style={sx?.header}>
                {title}
            </div>
            <div className="p-6 flex-1 w-full overflow-y-auto" style={sx?.body}>
                {children}
            </div>
            <div
                className="flex justify-between items-center h-16 p-4 bg-sf-white border-t border-sf-gray-100 rounded-b-2xl"
                style={sx?.footer}>
                <div>
                    {backButtonProps && (
                        <Button
                            text="Back"
                            iconLeft={Icons.ChevronLeft}
                            buttonStyle={ButtonStyles.TertiarySolid}
                            {...backButtonProps}
                        />
                    )}
                </div>
                <div className="flex gap-1">

                    {cancelButtonProps && (
                        <Button text="Cancel" buttonStyle={ButtonStyles.TertiarySolid} {...cancelButtonProps} />
                    )}
                    {nextButtonProps && (
                        <Button
                            text={'Next'}
                            iconRight={Icons.ChevronRight}
                            buttonStyle={ButtonStyles.PrimarySolid}
                            tooltip={nextButtonProps.disabled ? {title: 'Cannot proceed to the next step.'} : {}}
                            {...nextButtonProps}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default WizardPage;
